module.exports = __webpack_public_path__ + "media/images/test-7e8c2ca2e3d8406d7778359bfeec7ac9.png";